module.exports = __webpack_public_path__ + "img/15.610e87ce.jpg";